import React from 'react';
import styled from 'styled-components';
import Imgix from 'shared/components/imgix';

import useTranslation from 'hooks/use-translation';

import { TextButton } from 'components/core';
import { DesktopOnly, MobileOnly } from 'shared/components';
import { ListItemContainer } from '../../components';

const SubscriptionListItem = ({ dispensaryName, unSubscribed, location, onToggleSubscribe, dispensaryLogo }) => {
  const { t } = useTranslation();

  const label = unSubscribed ? t('common.subscribe', 'Subscribe') : t('common.Unsubscribe', 'Unsubscribe');

  return (
    <ListItemContainer>
      <MobileOnly>
        <Imgix
          fit='max'
          height={48}
          htmlAttributes={{ alt: `${dispensaryName} Logo` }}
          src={dispensaryLogo}
          width={60}
        />

        <MobileDetailContainer>
          <DispensaryName>{dispensaryName}</DispensaryName>
          <LocationLabel>{location}</LocationLabel>
        </MobileDetailContainer>
      </MobileOnly>

      <DesktopOnly>
        <DispensaryName>{dispensaryName}</DispensaryName>
      </DesktopOnly>

      <SubscribeButtonContainer>
        <TextButton onClick={onToggleSubscribe}>{label}</TextButton>
      </SubscribeButtonContainer>
    </ListItemContainer>
  );
};

export default SubscriptionListItem;

const DispensaryName = styled.h5`
  font-size: 14px;
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;

const LocationLabel = styled.div`
  margin-top: 7px;
  font-size: 13px;
`;

const MobileDetailContainer = styled.div`
  margin-left: 18px;
  padding-top: 6px;
`;

const SubscribeButtonContainer = styled.div`
  padding-top: 7px;
  padding-right: 15px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    padding-top: 2px;
  }}
`;
